var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M4.5 4.81827H3V6.77282H4.5V12.6365H7V6.77282H8.821L9 4.81827H7V4.00371C7 3.53707 7.096 3.35236 7.5575 3.35236H9V0.90918H7.096C5.298 0.90918 4.5 1.68269 4.5 3.16424V4.81827Z","fill":"#1A1D31"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"12","height":"11.7273","fill":"white","transform":"translate(0 0.90918)"})))]);
}

Facebook.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
